import { useTranslation } from "react-i18next";

import { RelationalValue, IClassroomResource } from "@sol/sdk";
import { ExternalLink } from "@sol/uikit/core/icons/ExternalLink";
import { Button } from "@sol/uikit/general/Button/Button";

import { useOpenClassroomWebinar } from "../hooks/useOpenClassroomWebinar";

type Props = {
    classroom: RelationalValue<IClassroomResource>;
    className?: string;
    dataCy?: string;
};

export const OpenClassroomWebinarButton = ({ classroom, className, dataCy }: Props) => {
    const [t] = useTranslation(undefined, { keyPrefix: "features.openClassroomWebinar" });
    const { openWebinar, isLoading } = useOpenClassroomWebinar({ classroom, t });

    return (
        <div className={className}>
            <Button
                type="primary"
                className="hover:cursor-pointer"
                icon={<ExternalLink size={16} />}
                iconPosition="start"
                loading={isLoading}
                onClick={openWebinar}
                aria-label={t("visioButton.title")}
                data-cy={dataCy}
            >
                {t("visioButton.text")}
            </Button>
        </div>
    );
};
